import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGamepad: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGamepad"><Path fillRule="evenodd" clipRule="evenodd" d="M1.25 5.25V18.75H22.75V5.25H1.25ZM8.75 9V11.25H11V12.75H8.75V15H7.25V12.75H5V11.25H7.25V9H8.75ZM18 11.25C17.4477 11.25 17 10.8023 17 10.25C17 9.69772 17.4477 9.25 18 9.25C18.5523 9.25 19 9.69772 19 10.25C19 10.8023 18.5523 11.25 18 11.25ZM15 14.75C14.4477 14.75 14 14.3023 14 13.75C14 13.1977 14.4477 12.75 15 12.75C15.5523 12.75 16 13.1977 16 13.75C16 14.3023 15.5523 14.75 15 14.75Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGamepad;
